import * as Reflux from "reflux";

export default {
    dismissLoginPrompt: Reflux.createAction("dismissLoginPrompt") as RefluxAction<[]>
};
